<template>
  <el-dialog v-dialogDrag :visible.sync="dialogAddAll" width="1300px" :close-on-click-modal="false"
    :before-close="resetAddAll">
    <span slot="title" class="dialog-title">添加总结算</span>
    <div class="dialoginfo">
      <el-form ref="reffromDate" :model="fromDate" :rules="rules" label-width="180px">
        <div style="display: flex">
          <el-form-item prop="currentSettlementQuantity">
            <span slot="label"><span style="color: red">送审本次结算数量（方）</span></span>
            <el-input v-model="fromDate.currentSettlementQuantity" style="width: 360px"
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              :disabled="isDisabledType" @input="updateSettlement"></el-input>
          </el-form-item>
          <el-form-item prop="cumulativeSettlementQuantity">
            <span slot="label"><span style="color: red">送审累计结算数量（方）</span></span>
            <el-input v-model="fromDate.cumulativeSettlementQuantity"
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              :disabled="isDisabledType" @input="updateSettlement"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex">
          <el-form-item prop="currentSettlementAmount">
            <span slot="label"><span style="color: red">送审本次结算金额（元）</span></span>
            <el-input v-model="fromDate.currentSettlementAmount" style="width: 360px"
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              :disabled="isDisabledType" @input="updateSettlement"></el-input>
          </el-form-item>
          <el-form-item prop="cumulativeSettlementAmount">
            <span slot="label"><span style="color: red">送审累计结算金额（元）</span></span>
            <el-input v-model="fromDate.cumulativeSettlementAmount"
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              :disabled="isDisabledType" @input="updateSettlement"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex">
          <el-form-item prop="settlementTime">
            <span slot="label"><span style="color: red">结算周期</span></span>
            <el-date-picker v-model="startTimDateEndTimDate" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :disabled="isDisabledType"
              @change="(fromDate.startTime = startTimDateEndTimDate[0] || ''), (fromDate.endTime = startTimDateEndTimDate[1] || '')">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="settlementNumber">
            <span slot="label"><span style="color: red">编号</span></span>
            <el-input v-model="fromDate.settlementNumber" :disabled="isDisabledType"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="审核说明" prop="auditNotes">
          <el-input v-model="fromDate.auditNotes" style="width: 750px" placeholder="请填写备注" class="textarea"
            type="textarea" resize="none" rows="3" :disabled="isDisabledType"></el-input>
        </el-form-item>
        <el-form-item label="事项说明" prop="internalEventExplain">
          <el-input v-model="fromDate.internalEventExplain" style="width: 750px" placeholder="请填写备注" class="textarea"
            type="textarea" resize="none" rows="3" :disabled="isDisabledType"></el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label"><span style="color: red">附件</span></span>
          <div style="padding-left: 42px" :style="isDisabledType ? 'pointer-events: none;' : ''">
            <FileComponent2 fileCode="modifyPriceFile" :files="files" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
          </div>
        </el-form-item>
        <div style="margin: 20px 0 10px 40px;">
          <span style="color: red; font-size: 14px;">盈余分析:</span>
        </div>
        <div style="display: flex">
          <el-form-item prop="surplusVolume">
            <span slot="label"><span style="color: red">价值表盈余量（方）</span></span>
            <el-input v-model="fromDate.surplusVolume" style="width: 360px" placeholder="请输入价值表盈余量"
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              :disabled="isDisabledType"></el-input>
          </el-form-item>
          <el-form-item prop="surplusAmount">
            <span slot="label"><span style="color: red">价值表盈余额（元）</span></span>
            <el-input v-model="fromDate.surplusAmount" placeholder="请输入价值表盈余额"
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              :disabled="isDisabledType"></el-input>
          </el-form-item>
        </div>
        <template v-for="(item, index) in fromDate.surplusAnalysisList">
          <div v-if="item.status !== 0" :key="index" style="display: flex; margin-bottom: 5px;">
            <el-form-item :prop="'surplusAnalysisList.' + index + '.disputeTypeId'">
              <span slot="label"><span>争议类型</span></span>
              <el-select v-model="item.disputeTypeId" placeholder="请选择争议类型" style="width: 360px" :disabled="isDisabledType" @change="(val) => handleDisputeTypeChange(val, item)">
                <el-option v-for="dict in disputeTypeOptions" :key="dict.id" :label="dict.itemName" :value="dict.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :prop="'surplusAnalysisList.' + index + '.disputeMoney'">
              <span slot="label"><span>金额（元）</span></span>
              <el-input v-model="item.disputeMoney" style="width: 240px" placeholder="请输入金额"
                onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
                onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
                :disabled="isDisabledType"></el-input>
            </el-form-item>
            <div style="line-height: 40px; margin-left: 20px;">
              <el-button v-if="!isDisabledType" type="text" style="color: red;" @click="addDispute(index)">添加</el-button>
              <el-button v-if="activeDisputeCount > 1 && !isDisabledType" type="text" style="color: red;" @click="removeDispute(index)">删除</el-button>
            </div>
          </div>
        </template>
        <el-form-item style="margin-top: 15px;">
          <span slot="label"><span style="color: red">附件</span></span>
          <div style="padding-left: 42px" :style="isDisabledType ? 'pointer-events: none;' : ''">
            <FileComponent2 fileCode="modifyPriceFile" :files="files2" @deleteFile="deleteFile2" @uplodeSuccess="uplodeSuccess2" />
          </div>
        </el-form-item>
        <div v-if="isBackType">
          <div style="display: flex">
            <el-form-item prop="returnSettlementQuantityCurrent">
              <span slot="label"><span>返回本次结算数量（方）</span></span>
              <el-input v-model="fromDate.returnSettlementQuantityCurrent" style="width: 360px"
                onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
                onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
                :disabled="isDisabledType"></el-input>
            </el-form-item>
            <el-form-item prop="returnSettlementQuantityCumulative">
              <span slot="label"><span>返回累计结算数量（方）</span></span>
              <el-input v-model="fromDate.returnSettlementQuantityCumulative"
                onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
                onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
                :disabled="isDisabledType"></el-input>
            </el-form-item>
          </div>
          <div style="display: flex">
            <el-form-item prop="returnSettlementAmountCurrent">
              <span slot="label"><span>返回本次结算金额（元）</span></span>
              <el-input v-model="fromDate.returnSettlementAmountCurrent" style="width: 360px"
                onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
                onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
                :disabled="isDisabledType"></el-input>
            </el-form-item>
            <el-form-item prop="returnSettlementAmountCumulative">
              <span slot="label"><span>返回累计结算金额（元）</span></span>
              <el-input v-model="fromDate.returnSettlementAmountCumulative"
                onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
                onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
                :disabled="isDisabledType"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="审核说明" prop="confirmAuditDescription">
            <el-input v-model="fromDate.confirmAuditDescription" style="width: 750px" placeholder="请填写备注" class="textarea"
              type="textarea" resize="none" rows="3" :disabled="isDisabledType"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label"><span style="color: red">附件</span></span>
            <div style="padding-left: 42px">
              <FileComponent2 fileCode="modifyPriceFile" :files="files1" @deleteFile="deleteFile1" @uplodeSuccess="uplodeSuccess1" />
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="resetAddAll">取 消</el-button>
      <el-button class="bottom_one" style="margin-left: 24px" @click="submitAll(0)">保 存</el-button>
      <el-button v-if="isDisabledType" class="bottom_one" style="margin-left: 24px" @click="submitAll(1)">提 交</el-button>
      <el-button v-if="fromDate.secondSure == 1 && fromDate.thirdSure == 1" class="bottom_three"
        style="margin-left: 24px" @click="confirmItem()"> 确 认 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";
import { saveSettlement } from "@/api/internetSales/engineeringControl.js";
import { getDicsType } from "@/api/common.js";

export default {
  components: {
    FileComponent2,
  },
  props: {
    dialogAddAll: { type: Boolean, default: false },
    params: { type: Object, default: () => ({}) },
    paramsFromDate: { type: Object, default: () => ({}) },
    isBack: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      files: [],     // 送审附件 (internalEnclosureUrl)
      files2: [],    // 盈余附件 (totalSettlementAttachment)
      files1: [],    // 返回附件 (confirmEnclosureUrl)
      isBackType: false,
      isDisabledType: false,
      startTimDateEndTimDate: [],
      disputeTypeOptions: [],
      rules: {
        currentSettlementQuantity: [{ required: true, message: "请输入送审本次结算数量", trigger: "blur" }],
        cumulativeSettlementQuantity: [{ required: true, message: "请输入送审累计结算数量", trigger: "blur" }],
        currentSettlementAmount: [{ required: true, message: "请输入送审本次结算金额", trigger: "blur" }],
        cumulativeSettlementAmount: [{ required: true, message: "请输入送审累计结算金额", trigger: "blur" }],
        settlementNumber: [{ required: true, message: "请输入编号", trigger: "blur" }],
        surplusVolume: [{ required: true, message: "请输入价值表盈余量", trigger: "blur" }],
        surplusAmount: [{ required: true, message: "请输入价值表盈余额", trigger: "blur" }],
      },
      fromDate: {
        id: "",
        currentSettlementQuantity: "",
        cumulativeSettlementQuantity: "",
        currentSettlementAmount: "",
        cumulativeSettlementAmount: "",
        settlementNumber: "",
        settlementTime: "",
        returnSettlementQuantityCurrent: "",
        returnSettlementQuantityCumulative: "",
        returnSettlementAmountCurrent: "",
        returnSettlementAmountCumulative: "",
        surplusVolume: "",
        surplusAmount: "",
        surplusAnalysisList: [{ disputeTypeId: "", disputeType: "", disputeMoney: "", status: 1 }], 
        startTime: "",
        endTime: "",
        type: 2
      },
    };
  },
  computed: {
    activeDisputeCount() {
      if (!this.fromDate.surplusAnalysisList) return 0;
      return this.fromDate.surplusAnalysisList.filter(item => item.status !== 0).length;
    }
  },
  watch: {
    dialogAddAll() {
      if (this.dialogAddAll) {
        this.row = this.params;
        this.isBackType = this.isBack;
        this.isDisabledType = this.isDisabled;
        this.fromDate = Object.assign(this.$options.data().fromDate, this.paramsFromDate);
        
        if (!this.fromDate.startTime) {
          this.startTimDateEndTimDate = [];
        } else {
          this.startTimDateEndTimDate = [this.fromDate.startTime, this.fromDate.endTime];
        }

        if (!this.fromDate.surplusAnalysisList || this.fromDate.surplusAnalysisList.length === 0) {
          this.$set(this.fromDate, 'surplusAnalysisList', [{ disputeTypeId: "", disputeType: "", disputeMoney: "", status: 1 }]);
        } else {
          this.fromDate.surplusAnalysisList.forEach(item => {
            if (item.status === undefined || item.status === null) {
              this.$set(item, 'status', 1);
            }
          });
        }

        if (this.fromDate.internalEnclosureUrl && this.fromDate.internalEnclosureUrl != "[]") {
          this.files = JSON.parse(this.fromDate.internalEnclosureUrl);
        } else {
          this.files = [];
        }
        
        if (this.fromDate.totalSettlementAttachment && this.fromDate.totalSettlementAttachment != "[]") {
          this.files2 = JSON.parse(this.fromDate.totalSettlementAttachment);
        } else {
          this.files2 = [];
        }

        if (this.fromDate.confirmEnclosureUrl && this.fromDate.confirmEnclosureUrl != "[]") {
          this.files1 = JSON.parse(this.fromDate.confirmEnclosureUrl);
        } else {
          this.files1 = [];
        }

        this.getDisputeDict();
        
        this.$nextTick(() => {
          if (this.$refs.reffromDate) {
            this.$refs.reffromDate.clearValidate();
          }
        });
      }
    },
  },
  methods: {
    async getDisputeDict() {
      if (this.disputeTypeOptions.length > 0) return;
      try {
        const { data } = await getDicsType({ codes: "zytype" });
        if (data && data.zytype && data.zytype.items) {
          this.disputeTypeOptions = data.zytype.items;
        }
      } catch (error) {
        console.error("获取争议类型字典失败", error);
      }
    },
    handleDisputeTypeChange(val, item) {
      const selectedOption = this.disputeTypeOptions.find(dict => dict.id === val);
      if (selectedOption) {
        item.disputeType = selectedOption.itemName;
      } else {
        item.disputeType = "";
      }
    },
    addDispute(index) {
      this.fromDate.surplusAnalysisList.splice(index + 1, 0, { disputeTypeId: "", disputeType: "", disputeMoney: "", status: 1 });
    },
    removeDispute(index) {
      const targetItem = this.fromDate.surplusAnalysisList[index];
      if (targetItem.id) {
        this.$set(this.fromDate.surplusAnalysisList[index], 'status', 0);
      } else {
        this.fromDate.surplusAnalysisList.splice(index, 1);
      }
    },
    updateSettlement() {
      this.fromDate.returnSettlementQuantityCurrent = this.fromDate.currentSettlementQuantity;
      this.fromDate.returnSettlementQuantityCumulative = this.fromDate.cumulativeSettlementQuantity;
      this.fromDate.returnSettlementAmountCurrent = this.fromDate.currentSettlementAmount;
      this.fromDate.returnSettlementAmountCumulative = this.fromDate.cumulativeSettlementAmount;
    },
    uplodeSuccess(data) {
      this.files = [];
      const params = { name: data.fileName, fileName: data.fileName, fileUrl: data.fileUrl, path: data.fileUrl, fileType: 1, type: 1, createTime: new Date().Format("yyyy-MM-dd hh:mm:ss") };
      this.files.push(params);
    },
    deleteFile(index) { this.files.splice(index, 1); },
    uplodeSuccess2(data) {
      const params = { name: data.fileName, fileName: data.fileName, fileUrl: data.fileUrl, path: data.fileUrl, fileType: 1, type: 1, createTime: new Date().Format("yyyy-MM-dd hh:mm:ss") };
      this.files2.push(params);
    },
    deleteFile2(index) { this.files2.splice(index, 1); },
    uplodeSuccess1(data) {
      const params = { name: data.fileName, fileName: data.fileName, fileUrl: data.fileUrl, path: data.fileUrl, fileType: 1, type: 1, createTime: new Date().Format("yyyy-MM-dd hh:mm:ss") };
      this.files1.push(params);
    },
    deleteFile1(index) { this.files1.splice(index, 1); },
    resetAddAll() {
      this.$emit("resetAddAll", false);
      this.$parent.init(this.row.id);
    },
    confirmItem() {
      this.$confirm("此操作将确认该数据, 是否继续?", "提示", {
        confirmButtonText: "确定", cancelButtonText: "取消", cancelButtonClass: "bottom_all_two", confirmButtonClass: "bottom_all", type: "warning",
      }).then(() => {
        var params = { id: this.fromDate.id, secondSure: 2, thirdSure: 2 };
        saveSettlement(params).then(res => {
          if (res.code == 1001) {
            this.$message.success("已确认该数据");
            this.resetAddAll();
          }
        });
      }).catch(() => { });
    },
    submitAll(status) {
      this.fromDate.attachment = JSON.stringify(this.files);
      this.fromDate.internalEnclosureUrl = JSON.stringify(this.files);
      this.fromDate.totalSettlementAttachment = JSON.stringify(this.files2);
      this.fromDate.confirmEnclosureUrl = JSON.stringify(this.files1);

      this.$refs.reffromDate.validate(valid => {
        if (valid) {
          this.fromDate.engineeringId = this.row.id;
          if (this.isDisabledType && this.fromDate.secondSure == 0) {
            this.fromDate.secondSure = status;
            this.fromDate.thirdSure = status;
          }
          
          saveSettlement(this.fromDate).then(res => {
            if (res.code == 1001) {
              this.$message({ message: "保存成功", type: "success" });
            } else {
              this.$message({ message: res.data, type: "warning" });
            }
            this.$emit("resetAddAll", false);
            this.$parent.init(this.row.id);
            this.files = [];
            this.files2 = [];
            this.files1 = [];
          });
        } else {
          this.$message.warning("请完善必填信息");
          return false;
        }
      });

      if (this.isDisabledType) {
        var params = { id: this.fromDate.id, secondSure: 1, thirdSure: 1 };
        saveSettlement(params).then(res => {
          if (res.code == 1001) {
            this.$message.success("已提交该数据");
            this.resetAddAll();
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.title {
  font-weight: bold;
  font-size: 18px;
  padding-bottom: 18px;
}
</style>